

















































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import CongestionGraphConfig from "./data/CongestionGraphConfig";
import CongestionGraphD3Renderer from "./renderer/CongestionGraphD3Renderer";

@Component
export default class CongestionGraphRenderer extends Vue {
    @Prop()
    public config!: CongestionGraphConfig;

    protected get connection(){
        return this.config.connection;
    }

    protected renderer: CongestionGraphD3Renderer | undefined = undefined;

    public created(){
        this.renderer = new CongestionGraphD3Renderer("congestion-graph");
        this.config.renderer = this.renderer;
    }

    public mounted(){
        // mainly for when we switch away, and then back to the congestionGraph
        if ( this.config && this.renderer && this.config.connection !== undefined ) {
            this.renderer.render( this.config );
        }
    }

    protected hideLegend(evt:any) {
        evt.target.classList.add("hiddenLegend");
    }

    protected showLegend(evt:any) {
        evt.target.classList.remove("hiddenLegend");
    }

    // Note: we could use .beforeUpdate or use an explicit event or a computed property as well
    // however, this feels more explicit
    @Watch('config', { immediate: true, deep: true })
    protected onConfigChanged(newConfig: CongestionGraphConfig, oldConfig: CongestionGraphConfig) {
        console.log("CongestionGraphRenderer:onConfigChanged : ", newConfig, oldConfig);

        if ( this.renderer && newConfig.connection !== undefined ) {
            this.renderer.render( newConfig );
        }
    }

}

